module.exports = {
    mobile: "0px",
    sm: "620px",
    md: "760px",
    lg: "1020px",
    xl: "1300px",
    xxl: "1440px",
    // values below map to lineup breakpoints
    /* eslint-disable inclusive-language/use-inclusive-words */
    // https://bbgithub.dev.bloomberg.com/Consumer-Web/javelin/blob/master/src/hub/sass/_when-than.scss
    // mob = mobile
    // tab = tablet
    // sdt = small desktop
    // ldt = large desktop
    // tup substitutes for when-wider-than(tablet)
    // sdu substitutess for when-wider-than(small-desktop)
    // sdd substitutes for when-less-than(small-desktop)
    mob: { max: "759px" },
    tab: { min: "760px", max: "1019px" },
    sdt: { min: "1020px", max: "1279px" },
    ldt: { min: "1280px" },
    tup: { min: "760px" },
    sdu: { min: "1020px" },
    sdd: { max: "1019px" },
    // allow for @media (orientation: landscape)
    landscape: {
        raw: "(orientation: landscape)",
    },
    "landscape-lg": {
        raw: "(orientation: landscape) and (min-width: 1025px)",
    },
    portrait: {
        raw: "(orientation: portrait)",
    },
    // Grid Layout Breakpoints
    "mob-grid": { max: "767px" },
    "tab-grid": { min: "768px", max: "911px" },
    "tup-grid": "768px",
    "tup-grid-below": { min: "767px" },
    "xsdt-grid": { min: "912px", max: "1122px" },
    "xsdd-grid": { max: "911px" },
    "xsdu-grid": "912px",
    "sdt-grid": { min: "1123px", max: "1334px" },
    "sdd-grid": { max: "1122px" },
    "sdu-grid": "1123px",
    "sdup-grid": { min: "1123px" },
    "ldt-grid": "1335px",
};
